import BlogIcon from "../icon/BlogIcon";
import CategoriesIcon from "../icon/CategoriesIcon";
import UsersIcon from "../icon/UsersIcon";
import ReviewsIcon from "../icon/ReviewsIcon";
import TeamIcon from "../icon/TeamIcon";



export const sidebarLinks = [

  { title: "Програми", icon: CategoriesIcon, path: "/programs" },
  { title: "Заявки", icon: UsersIcon, path: "/users" },
  // { title: "Контент", icon: BlogIcon, path: "/content" },
  { title: "Відгуки", icon: ReviewsIcon, path: "/reviews" },
  { title: "Команда", icon: TeamIcon, path: "/team" },
  { title: "Головний тест", icon: CategoriesIcon, path: "/placement-tests" },
  { title: "Міні тест", icon: CategoriesIcon, path: "/quick-placement-tests" },
  { title: "Сесії головного тесту", icon: UsersIcon, path: "/placement-tests-sessions" },
  { title: "Сесії міні тесту", icon: UsersIcon, path: "/quick-placement-tests-sessions" },
  { title: "Дитячий тест", icon: CategoriesIcon, path: "/kids-tests" },
  { title: "Сесії дитячого тесту", icon: UsersIcon, path: "/kids-tests-sessions" },
];
